<template>
  <div style="width: 100%">
    <div class="audio flex_audio" flex v-if="!mobile && !isLineFile">
      <div class="audio-icon">
        <img :src="audioIcon" alt="" />
      </div>
      <div class="audio-controls">
        <div class="audio-controls--handler flex_box">
          <div class="current-time">{{ playCurrentTime }}</div>
          <div class="play">
            <img
              class="play-handler"
              :src="isPlay ? pauseIcon : playIcon"
              @click.stop="play"
            />
            <!--            <i :class="isPlay ? 'el-icon-video-pause' : 'el-icon-video-play'" ></i>-->
          </div>
          <div class="total-time">{{ playDuration }}</div>
        </div>
        <div class="audio-controls--progress">
          <el-slider
            :disabled="playbackControl === '1'"
            v-model="playTime"
            :max="totalDuration"
            @change="changeTime"
            :show-tooltip="false"
          ></el-slider>
        </div>
      </div>
    </div>

    <div v-else>
      <img
        class="play-handler mobile"
        :src="isPlay ? pauseIcon : playIcon"
        @click.stop="isShowPlay = true"
      />

      <el-dialog
        width="100%"
        top="60px"
        custom-class="video-play--dialog"
        destroy-on-close
        append-to-body
        :visible.sync="isShowPlay"
      >
        <div class="audio" flex>
          <div class="audio-icon">
            <img :src="audioIcon" alt="" />
          </div>

          <div class="audio-controls" flex="dir:top main:justify">
            <div
              class="audio-controls--handler"
              flex="main:justify cross:center"
            >
              <div class="current-time">{{ playCurrentTime }}</div>
              <div class="play">
                <img
                  class="play-handler"
                  :src="isPlay ? pauseIcon : playIcon"
                  @click.stop="play"
                />
                <!--            <i :class="isPlay ? 'el-icon-video-pause' : 'el-icon-video-play'" ></i>-->
              </div>
              <div class="total-time">{{ playDuration }}</div>
            </div>
            <div class="audio-controls--progress">
              <el-slider
                :disabled="playbackControl === '1'"
                v-model="playTime"
                :max="totalDuration"
                @change="changeTime"
                :show-tooltip="false"
              ></el-slider>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <audio
      ref="musicAudio"
      class="audio-component"
      controls
      preload="auto"
      @canplay="changeDuration"
      @timeupdate="updateTime"
      @pause="isPlay = false"
      :src="url"
    ></audio>
  </div>
</template>

<script>
import playIcon from "@/assets/images/play-filling.png";
import pauseIcon from "@/assets/images/pause-fill.png";
import audioIcon from "@/assets/images/audio.png";
export default {
  name: "audio-play",
  props: {
    url: {
      type: String,
      default: "",
      require: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    isLineFile: {
      type: Boolean,
      default: false,
    },
    playbackControl: {
      type: String,
      default: "0",
    },
  },
  watch: {
    url: {
      handler() {
        this.isPlay = false;
      },
    },
  },
  data() {
    return {
      playIcon,
      pauseIcon,
      audioIcon,
      isPlay: false,
      playTime: 0,
      playDuration: "00:00",
      playCurrentTime: "00:00",
      totalDuration: 0,
      isShowPlay: false,
    };
  },
  methods: {
    changeDuration() {
      this.$nextTick(() => {
        this.playDuration = this.timeFormat(this.$refs.musicAudio.duration);
        this.totalDuration = this.$refs.musicAudio.duration;
      });
    },
    //将单位为秒的的时间转换成mm:ss的形式
    timeFormat(num) {
      let minute = parseInt(num / 60);
      let second = parseInt(num % 60);
      minute = minute >= 10 ? minute : "0" + minute;
      second = second >= 10 ? second : "0" + second;
      return minute + ":" + second;
    },
    play() {
      // console.log()
      let audio = document.querySelectorAll("audio");
      audio.forEach((i) => i.pause());
      let video = document.querySelectorAll("video");
      if (video && video.length) {
        video.forEach((i) => i.pause());
      }

      this.isPlay
        ? this.$refs.musicAudio.pause()
        : this.$refs.musicAudio.play();

      this.isPlay = !this.isPlay;

      this.$emit("play");
    },
    updateTime() {
      this.playTime = this.$refs.musicAudio.currentTime;
      this.playCurrentTime = this.timeFormat(this.$refs.musicAudio.currentTime);
      if (this.playTime >= this.totalDuration) {
        this.isPlay = false;
      }
    },
    changeTime(val) {
      this.$refs.musicAudio.currentTime = val;
    },
  },
};
</script>

<style scoped lang="scss">
.audio {
  .audio-icon {
    width: 36px;
    height: 36px;
    margin-right: 20px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .audio-controls {
    width: 100%;
    max-width: 200px;
    flex: 1;
    height: 36px;
    .audio-controls--progress,
    .audio-controls--handler {
      width: 100%;
    }

    .audio-controls--handler {
      line-height: 1;
      .play {
        font-size: 24px;

        .play-handler {
          width: 22px;
          height: 22px;
          display: block;
          cursor: pointer;
        }
      }
      .current-time,
      .total-time {
        font-size: 12px;
        color: #333;
      }
    }
  }
}
.play-handler {
  &.mobile {
    width: 20px;
    height: 20px;
  }
}
.audio-component {
  display: none;
}
::v-deep .el-slider__runway {
  margin: 0 0 4px 0;
  background: #e3e3e3;
  height: 4px;
}
::v-deep .el-slider__bar {
  height: 4px;
}

::v-deep .el-slider__button {
  width: 10px;
  height: 10px;
}

::v-deep .el-slider__button-wrapper {
  top: -15px;
}
.flex_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 5px;
}
.flex_audio {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
